import React, { useEffect, useState } from 'react';
import '../../styles/Events.css';
import { PhotoProvider, PhotoView } from 'react-photo-view';
import 'react-photo-view/dist/react-photo-view.css';
import axiosPost from '../../helper/axios-helper';
import { useParams } from 'react-router-dom';

export default function CantoConnect() {
    const { id } = useParams();
    const [event, setEvent] = useState();
    const [pastEvents, setPastEvents] = useState([]);
    const [images, setImages] = useState([]);

  const renderPastEvents = () => {
    const past_events = pastEvents.map((pastEvent, index) => {
        return (
            <a 
                key={pastEvent.id} 
                className='past-event-item' 
                href={pastEvent.album_link || '#'} 
                target='_blank'
                rel='noopener noreferrer'
            >
                <div className='past-event-item-image' style={{backgroundImage: `url(${pastEvent.image})`}}></div>
                <div className='past-event-item-info'>
                    <div className='past-event-item-title'>{pastEvent.name}</div>
                    <div className='past-event-item-sub'><span>Venue:</span> {pastEvent.venue}</div>
                    <div className='past-event-item-sub'><span>Dates:</span> {pastEvent.date_from} - {pastEvent.date_to}</div>
                </div>
                {pastEvent.album_link && (
                    <div className='past-event-item-btn' style={{background: event?.color || '#40B6BF'}}>View Album</div>
                )}
            </a>
        )
    })

    return past_events;
  }

  const EventPhotos = ({ images }) => {
        if (!images || images.length === 0) {
            return null;
        }
        
        return (
            <PhotoProvider>
                <div className='event-photos-container'>
                    {images.map((item, index) => (
                        <PhotoView key={index} src={item}>
                            <img src={item} alt='' className='event-photo'/>
                        </PhotoView>
                    ))}
                    {event?.album_link && (
                        <a className='event-photos-btn' style={{background: event?.color || '#40B6BF'}} href={event?.album_link} target='_blank' rel='noopener noreferrer'>View Full Album</a>
                    )}
                </div>

            </PhotoProvider>
        )
    };

    useEffect(() => {
        fetchContent();
    }, [])

    const fetchContent = () => {
        axiosPost('event/canto_connect/fetch', {}, {}, (data) => {
            const { success, response, event } = data;

            if (success) {
                setEvent(event);
                setImages(event.images || []);
                setPastEvents(event.past_events || []);
            } else {
                console.error('Failed to fetch event:', response);
            }
        })
    }

  return (
    <div className='container'>
        <div className='events-header-container' style={{backgroundImage: `url(${event?.image})`}}>
            <div className='events-header-content'>
                <img className='events-heaader-content-image' src={`${event?.logo}`} />
                <div className='events-header-title'>
                    {event?.title}
                </div>
                <div style={{display: 'flex', gap: '15px'}}>
                    {event?.c2a && (
                        <a href={event.c2a} target='_blank' rel='noopener noreferrer' className='events-header-btn' style={{background: event?.color || '#40B6BF'}}>
                            {event?.button_text || 'Read more'}
                        </a>
                    )}
                    {event?.c2a_secondary && (
                        <a href={event.c2a_secondary} target='_blank' rel='noopener noreferrer' className='events-header-btn' style={{background: event?.color || '#40B6BF', opacity: 0.85}}>
                            {event?.button_text_secondary || 'Learn More'}
                        </a>
                    )}
                </div>
            </div>
        </div>

        <div className='events-stats-container' style={{background: event?.color || '#40B6BF'}}>
            {(() => {
                try {
                    const stats = event?.stats ? JSON.parse(event.stats) : [];
                    return stats.map((stat, index) => (
                        <div className='event-stat-item' key={index}>
                            <div className='event-stat-number'>{stat.number}</div>
                            <div className='event-stat'>{stat.label}</div>
                        </div>
                    ));
                } catch (e) {
                    return null;
                }
            })()}
        </div>

        <div className='event-content' dangerouslySetInnerHTML={{ __html: event?.content || '' }} />

        <div className='events-presentation-container'>
            <div className='events-presentation-video-container' style={{width: images && images.length > 0 ? '' : '100%', marginLeft: images && images.length > 0 ? '' : '50px'}}>
                {event?.main_media ? (
                    (() => {
                        // Check if it's a YouTube URL
                        const youtubeMatch = event.main_media.match(/(?:youtube\.com\/(?:[^\/]+\/.+\/|(?:v|e(?:mbed)?)\/|.*[?&]v=)|youtu\.be\/)([^"&?\/\s]{11})/);
                        if (youtubeMatch) {
                            return (
                                <iframe
                                    style={{height: '100%', width: '100%', border: 'none'}}
                                    src={`https://www.youtube.com/embed/${youtubeMatch[1]}`}
                                    title="YouTube video player"
                                    frameBorder="0"
                                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                                    allowFullScreen
                                />
                            );
                        }
                        // Check if it's a video file
                        if (event.main_media.match(/\.(mp4|webm|ogg)$/i)) {
                            return (
                                <video style={{height: '100%', width: '100%'}} controls autoPlay loop onError={(e) => console.log(e)}>
                                    <source src={event.main_media} type="video/mp4" />
                                </video>
                            );
                        }
                        // Otherwise it's an image
                        return (
                            <img 
                                src={event.main_media} 
                                alt={event.name} 
                                style={{height: '100%', width: '100%', objectFit: 'cover'}} 
                            />
                        );
                    })()
                ) : (
                    <video style={{height: '100%', width: '100%'}} controls autoPlay loop onError={(e) => console.log(e)}>
                        <source src={`${process.env.PUBLIC_URL}/assets/videos/Canto_video.mp4`} type="video/mp4" />
                    </video>
                )}
            </div>
            {images && images.length > 0 && <EventPhotos images={images}/>}

        </div>

        <div className='past-events-container'>
            <div className='past-events-title'>Past Events</div>
            <div className='past-events'>
                {renderPastEvents()}
            </div>
        </div>
    </div>
  )
}
